import { LiveopsRewardType } from '@/modules/liveops/item/types';

const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const PointEventList = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/point-event.vue');
const LuxuryTableList = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/luxury-table.vue');
const LiveopsAdd = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/add.vue');
const LiveopsEdit = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/edit.vue');
const LiveopsContentEdit = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/edit-content.vue');
const LiveopsDetail = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/detail.vue');
const LiveopsTranslate = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/item/view/translate.vue');

const MilestoneList = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/milestone/view/index.vue');
const MilestoneAdd = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/milestone/view/add.vue');
const LeaderboardList = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/leaderboard/view/index.vue');
const LeaderboardAdd = () => import(/* webpackChunkName: "exoty" */ '@/modules/liveops/leaderboard/view/add.vue');

export const ROUTE_NAME_LIVEOPS = {
    ITEM: {
        INDEX: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventList' : 'LuxuryTableList',
        ADD: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventAdd' : 'LuxuryTableAdd',
        CLONE: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventClone' : 'LuxuryTableClone',
        EDIT: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventEdit' : 'LuxuryTableEdit',
        EDIT_CONTENT: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventContentEdit' : 'LuxuryTableContentEdit',
        DETAIL: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventDetail' : 'LuxuryTableDetail',
        TRANSLATE: (rewardType: LiveopsRewardType) =>
            rewardType == LiveopsRewardType.Milestone ? 'PointEventTranslate' : 'LuxuryTableTranslate'
    },
    MILESTONE: {
        INDEX: 'MilestoneList',
        ADD: 'MilestoneAdd'
    },
    LEADERBOARD: {
        INDEX: 'LeaderboardList',
        ADD: 'LeaderboardAdd'
    }
};

export default [
    {
        path: '/app/:appId/liveops/point-event',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_LIVEOPS.ITEM.INDEX(LiveopsRewardType.Milestone),
                component: PointEventList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_LIVEOPS.ITEM.ADD(LiveopsRewardType.Milestone),
                component: LiveopsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_LIVEOPS.ITEM.CLONE(LiveopsRewardType.Milestone),
                component: LiveopsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_LIVEOPS.ITEM.EDIT(LiveopsRewardType.Milestone),
                component: LiveopsEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/content/edit',
                name: ROUTE_NAME_LIVEOPS.ITEM.EDIT_CONTENT(LiveopsRewardType.Milestone),
                component: LiveopsContentEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/detail',
                name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(LiveopsRewardType.Milestone),
                component: LiveopsDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: ROUTE_NAME_LIVEOPS.ITEM.TRANSLATE(LiveopsRewardType.Milestone),
                component: LiveopsTranslate,
                meta: { requiresAuth: true }
            },
            {
                path: ':itemId/milestone/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_LIVEOPS.MILESTONE.INDEX,
                        component: MilestoneList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_LIVEOPS.MILESTONE.ADD,
                        component: MilestoneAdd,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    },

    {
        path: '/app/:appId/liveops/luxury-table',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_LIVEOPS.ITEM.INDEX(LiveopsRewardType.Leaderboard),
                component: LuxuryTableList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_LIVEOPS.ITEM.ADD(LiveopsRewardType.Leaderboard),
                component: LiveopsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/clone',
                name: ROUTE_NAME_LIVEOPS.ITEM.CLONE(LiveopsRewardType.Leaderboard),
                component: LiveopsAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_LIVEOPS.ITEM.EDIT(LiveopsRewardType.Leaderboard),
                component: LiveopsEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/content/edit',
                name: ROUTE_NAME_LIVEOPS.ITEM.EDIT_CONTENT(LiveopsRewardType.Leaderboard),
                component: LiveopsContentEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/detail',
                name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(LiveopsRewardType.Leaderboard),
                component: LiveopsDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: ROUTE_NAME_LIVEOPS.ITEM.TRANSLATE(LiveopsRewardType.Leaderboard),
                component: LiveopsTranslate,
                meta: { requiresAuth: true }
            },

            {
                path: ':itemId/leaderboard/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_LIVEOPS.LEADERBOARD.INDEX,
                        component: LeaderboardList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_LIVEOPS.LEADERBOARD.ADD,
                        component: LeaderboardAdd,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
